// extracted by mini-css-extract-plugin
module.exports = {"smartDevicesTreaserPC":"treaser_smartDevicesTreaserPC__VEBCN"};